import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const StarIcon = ({
  width = "24",
  height = "24",
  color = "#1B3967",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.12L12 2.5L9.19 9.12L2 9.74L7.45 14.47L5.82 21.5L12 17.77Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
